'use client';
var APP_ITEM_VARIANTS = [
    "appstore",
    "appgallery",
    "googleplay",
    "galaxystore",
    "rustore",
    "getapps",
    "download",
    "howtoinstall"
];

export { APP_ITEM_VARIANTS };
